<template>
  <v-container>
    <v-row>
      <v-col
        cols="12"
        md="4"
      >
        <b>Cleaning supplies</b>
      </v-col>
      <v-col
        cols="3"
        md="2"
      >
        <b>Unit price</b>
      </v-col>
      <v-col
        cols="3"
        md="2"
      >
        <b>Quantity</b>
      </v-col>
      <v-col
        cols="3"
        md="2"
      >
        <b>Total</b>
      </v-col>
      <v-col
        cols="3"
        md="2"
      >
      </v-col>
      <v-col cols="12">
        <hr />
      </v-col>
    </v-row>
    <v-row
      v-for="(item, i) in customer_supply_detail_list"
      :key="i"
    >
      <v-col
        cols="12"
        md="4"
      >
        <app-autocomplete
          :object_name="i"
          :api_url="'/cleaning-supplies'"
          :attribute_search="'name'"
          :label="'Cleaning supply name'"
          @returnKeywordId="returnKeywordId"
        />
      </v-col>
      <v-col
        cols="3"
        md="2"
      >
        <v-text-field
          v-model="item.unit_price"
          type="number"
          outlined
          dense
          @input="updateSupplyTotal(i)"
        />
      </v-col>
      <v-col
        cols="3"
        md="2"
      >
        <v-text-field
          v-model="item.quantity"
          type="number"
          outlined
          dense
          @input="updateSupplyTotal(i)"
        />
      </v-col>
      <v-col
        cols="3"
        md="2"
      >
        <v-text-field
          v-model="item.total"
          type="number"
          outlined
          dense
          @input="updateUnitPrice(i)"
        />
      </v-col>
      <v-col
        cols="3"
        md="2"
      >
        <v-btn
          @click="removeRow(i)"
          small
          text
          color="red"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="12">
        <hr />
      </v-col>
    </v-row>
    <v-btn
      @click="addNewRow()"
      small
    >
      Add new supply
    </v-btn>
    <v-row>
      <v-col
        cols="3"
        md="2"
        offset-md="6"
      >
        <b>Total</b>
      </v-col>
      <v-col
        cols="3"
        md="2"
      >
        {{ updateTotal }}
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { authHeader } from '../../../_helpers'
export default {
  name: 'CustomerSupplyDetail',
  props: ['customer_supply_detail_list'],
  components: {
    AppAutocomplete: () => import('../../../components/AppAutocomplete')
  },
  data: () => ({ }),
  mounted () {
    if (!this.customer_supply_detail_list.length)
      this.customer_supply_detail_list.push({
        cleaning_supply_id: null, cleaning_supply_name: null,
        unit_price: 0, quantity: 1, total: 0
      })
  },
  methods: {
    async createCustomerSupply () {
      try {
        if (this.requireField()) {
          
          // this.$router.push({ name: 'customer-supply-list'})
        }
      } catch (err) {
        console.log(err)
        alert('Something went wrong')
      }
    },
    addNewRow () {
      this.customer_supply_detail_list.push({
        cleaning_supply_id: null, cleaning_supply_name: null,
        unit_price: 0, quantity: 1, total: 0
      })
    },
    removeRow (index) {
      this.customer_supply_detail_list.splice(index, 1)
    },
    async returnKeywordId (object) {
      try {
        const { data } = await this.$http.get(`/back-office/cleaning-supplies/${object.id}`, authHeader())
        let index = object.object_name
        this.customer_supply_detail_list[index].cleaning_supply_name = data.name
        this.customer_supply_detail_list[index].cleaning_supply_id = data.id
        this.customer_supply_detail_list[index].unit_price = data.price
        this.customer_supply_detail_list[index].total =
          this.customer_supply_detail_list[index].unit_price * this.customer_supply_detail_list[index].quantity
      } catch (err) {
        if (err.response)
          alert(err.response)
        else
          alert('Something went wrong')
      }
    },
    updateSupplyTotal (index) {
      this.customer_supply_detail_list[index].total = 
        this.customer_supply_detail_list[index].unit_price * this.customer_supply_detail_list[index].quantity
    },
    updateUnitPrice (index) {
      this.customer_supply_detail_list[index].unit_price =
        this.customer_supply_detail_list[index].total / this.customer_supply_detail_list[index].quantity
    },
  },
  computed: {
    updateTotal () {
      let total = 0
      for (let item of this.customer_supply_detail_list) {
        total += item.total
      }
      return total
    }
  }
}
</script>